__turbopack_context__.v({
  "is_active": "Tab-module-scss-module__wnxuWW__is_active",
  "tab_link": "Tab-module-scss-module__wnxuWW__tab_link",
});
